import {
	fetchPlayerConfig,
	fetchMovieDetails,
	fetchContinueWatchingData,
	fetchMovieEpisodesPrevNext,
	fetchRecommendations
} from 'store/actions';
import { PLAYER_SELECTORS, PRODUCTS_TYPES } from 'helpers/variables';

export const fetchMovieResources = ({
	uuid,
	type,
	videoId = null,
	isAuth = true,
	isMovieDetails = false
}) => async (dispatch) => {
	const isEpisode = type === 'seriale';

	// fetch additional data if the material is not a movie trailer
	if (!videoId) {
		if (isAuth) {
			await fetchContinueWatchingData(uuid)(dispatch);
		}

		if (isEpisode) {
			await fetchMovieEpisodesPrevNext(uuid, dispatch);
		} else {
			await fetchRecommendations(uuid, PRODUCTS_TYPES.VOD, dispatch);
		}
	}

	if (!isMovieDetails) {
		await fetchMovieDetails(uuid, PRODUCTS_TYPES.VOD, dispatch);
	}

	await dispatch(
		fetchPlayerConfig({
			uuid,
			playerType: PLAYER_SELECTORS.VOD,
			type: PRODUCTS_TYPES.VOD,
			videoId,
			isAuth
		})
	);
};
